import * as React from "react";
import { Switch, Route, RouteComponentProps, Link } from "react-router-dom";
import { Spin, Menu, Popover, Icon, Button, Breadcrumb } from "antd";
import { withMsal } from "@azure/msal-react";

import ErrorModal from "../../Common/ErrorHandler";
import { getViewport } from "../../../utils";
import { ViewportType } from "../types";
import Spinicon from "../../Common/Spinicon";
import SearchHome from "../../SearchHome";
import BusinessPartnerDetails from "../../BusinessPartnerDetails";
import RejectedBusinessPartnersComponent from "../../RejectedBusinessPartners";
import BusinessPartnerListComponent from "../../BusinessPartnerLists";
import StewardBusinessPartnerLists from "../../StewardBusinessPartnerLists";
// import { adalUserInfo, notificationPollingRate } from "../../../config/adal";
import { notificationPollingRate } from "../../../config/msal/authConfig";
import "../style.scss";
import { UserInfoType } from "../types";
import UserInfo from "../../Common/UserInfo";
import Notification from "../../Notification";
import ChangeLog from "../../ChangeLog";
import NotFound from "../../Common/NotFound";
const logoPath = "/assets/images/logo.png";

interface AppProps extends RouteComponentProps<any> {
  isLoading: number;
  userInfo: UserInfoType | null;
  notificationUpdated: boolean;
  menuKey: string;
  updateViewport: (viewport: ViewportType) => any;
  setUserInfo: (userInfo: UserInfoType) => any;
  fetchNotificaton: () => any;
  resetNotificationUpdatedFlag: () => any;
  msalContext: any;
}

interface AppState {}
const breadcrumbNameMap = {
  "/": "Search",
  "/business-partner-details": "Create New BP",
  "/search": "Business Partners",
  "/rejected-business-partners": "Rejected BPs",
  "/change-log": "Change Log",
  "/business-partners": "BPs List",
  "/business-partner-details/:bpID?": "Update BP",
};

class AppComponent extends React.Component<AppProps, AppState> {
  private resizeTracker: any;
  private NotificationTracker: any;
  constructor(props: AppProps) {
    super(props);
    // const { instance, accounts } = useMsal();
    this.state = {};
    this.resizeTracker = null;
  }
  componentDidMount() {
    // this.props.setUserInfo(adalUserInfo());
    window.addEventListener("resize", this.resizeHandler, false);
    this.resizeHandler();
    this.props.fetchNotificaton();

    // notificatgit stion polling for fetching updated notifications.
    // get polling internal;
    const pollingInterval = !isNaN(parseInt(notificationPollingRate))
      ? parseInt(notificationPollingRate)
      : 60;

    this.NotificationTracker = setInterval(
      () => this.props.fetchNotificaton(),
      pollingInterval * 1000
    );
  }
  componentDidUpdate(prevProps) {
    const { notificationUpdated } = this.props;
    if (notificationUpdated && !prevProps.notificationUpdated) {
      // fetch notifications
      this.props.fetchNotificaton();
      this.props.resetNotificationUpdatedFlag();
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeHandler, false);
    clearTimeout(this.NotificationTracker);
  }
  updateDimension = () => {
    const viewport = getViewport();
    this.props.updateViewport(viewport);
  };
  resizeHandler = () => {
    clearTimeout(this.resizeTracker);
    this.resizeTracker = setTimeout(() => this.updateDimension, 16);
  };
  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  };
  render() {
    const { isLoading, userInfo, location, msalContext } = this.props;
    const isAuthenticated = msalContext.accounts.length > 0;
    let roles = [];
    if (isAuthenticated) {
      roles = msalContext.accounts[0].idTokenClaims.roles || [];
    }

    const pathSnippets = location.pathname.split("/").filter((i) => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
      if (index === pathSnippets.length - 1) {
        return (
          <Breadcrumb.Item key={url}>{breadcrumbNameMap[url]}</Breadcrumb.Item>
        );
      }
      return (
        <Breadcrumb.Item key={url}>
          <Link to={url}>{breadcrumbNameMap[url]}</Link>
        </Breadcrumb.Item>
      );
    });

    const breadcrumbItems = [
      <Breadcrumb.Item key="Search">
        <Link to="/">Search</Link>
      </Breadcrumb.Item>,
    ].concat(extraBreadcrumbItems);

    return (
      <Spin
        indicator={Spinicon}
        spinning={isLoading > 0}
        wrapperClassName="global-loading-spinner"
      >
        <header className="header">
          <div className="header-inner-wrapper">
            <h1>
              <Link to="/" title="Go to home">
                <img
                  src={logoPath}
                  alt="Nedschroef"
                  style={{ height: 19, width: 211 }}
                />
              </Link>
            </h1>
            <div className="top-link-right">
              <nav>
                <Menu selectedKeys={[this.props.menuKey]} mode="horizontal">
                  <Menu.Item
                    key="business partner details"
                    title="Create New BP"
                  >
                    <Link to="/business-partner-details">Create New BP</Link>
                  </Menu.Item>
                  {roles.indexOf("DataSteward") > -1 && (
                      <Menu.Item
                        key="steward business partner lists"
                        title="Steward Business partner lists"
                      >
                        <Link to="/business-partners">BPs List</Link>
                      </Menu.Item>
                    )}
                  <Menu.Item
                    key="rejected business partners"
                    title="Rejected BP"
                  >
                    <Link to="/rejected-business-partners">Rejected BPs</Link>
                  </Menu.Item>
                  <Menu.Item key="change log" title="Change Log">
                    <Link to="/change-log">Change Log</Link>
                  </Menu.Item>
                </Menu>
              </nav>
              <Notification />
              {<UserInfo userInfo={userInfo} />}
            </div>
          </div>
        </header>
        <div className="main-container">
          {extraBreadcrumbItems.length > 0 && (
            <Breadcrumb separator=">">{breadcrumbItems}</Breadcrumb>
          )}
        </div>
        <main>
          <Switch>
            <Route path="/" exact component={SearchHome} />
            <Route
              path="/business-partner-details/:bpID?"
              exact
              component={BusinessPartnerDetails}
            />
            <Route
              path="/rejected-business-partners"
              exact
              component={RejectedBusinessPartnersComponent}
            />
            {roles.indexOf("DataSteward") > -1 && (
              <Route
                path="/business-partners"
                exact
                component={StewardBusinessPartnerLists}
              />
            )}
            <Route
              path="/search/:query?"
              exact
              component={BusinessPartnerListComponent}
            />
            <Route path="/change-log" exact component={ChangeLog} />
            <Route path="*" component={NotFound} />
          </Switch>
        </main>
        <ErrorModal />
      </Spin>
    );
  }
}

// const YourWrappedComponent = withMsal(AppComponent);
// export default withMsal<any>(AppComponent);
export default withMsal(AppComponent); ;
